import { Pipe, PipeTransform } from '@angular/core';
import { MediaItem, TravelItem, TravelItemMinimal } from '../../api/models';

@Pipe({
  name: 'travelImagePipe',
})
export class TravelImagePipe implements PipeTransform {
  transform(
    value: TravelItem | TravelItemMinimal | undefined
  ): MediaItem | undefined {
    if (value && value.medias.length > 0) {
      return value.medias[0].media;
    } else if (
      value &&
      value.countries &&
      value.countries[0].country.medias &&
      value.countries[0].country.medias.length > 0 &&
      value.countries[0].country.medias[0].media
    ) {
      return value.countries[0].country.medias[0].media;
    }
    return undefined;
  }
}
